<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6 login-section-wrapper">
        <div class="brand-wrapper">
          <img
            src="@/assets/images/brand/logo.png"
            alt="Findus logo"
            class="logo"
          />
        </div>
        <div class="login-wrapper my-auto">
          <h1 class="login-title">Verifica OTP</h1>
          <form action="#!">
            <div class="form-group mb-4">
              <label for="email">Email</label>
              <input
                type="email"
                name="email"
                id="email"
                class="form-control"
                placeholder="email@example.com"
                v-model.trim="$v.email.$model"
              />
            </div>
            <div class="form-group mb-4">
              <label for="otp">OTP</label>
              <input
                type="text"
                name="otp"
                id="otp"
                class="form-control"
                placeholder="*******"
                v-model.trim="$v.otp.$model"
              />
            </div>
            <LoadingButton
              :text="'Verifica'"
              :classes="['btn', 'btn-block', 'login-btn', 'w-100']"
              :loading="loading"
              :disabled="$v.$invalid"
              @click="verifyOtp()"
            />
          </form>
          <router-link :to="{ name: 'SignupPage' }" class="forgot-password-link"
            >Non hai un account? Registrati</router-link
          >
        </div>
      </div>
      <div class="col-sm-6 px-0 d-none d-sm-block">
        <img :src="image" alt="login image" class="login-img" />
      </div>
    </div>
  </div>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import UsersService from "@/services/users";

export default {
  data() {
    return {
      email: "",
      otp: "",
      error: "",
      loading: false,
      image: "/static/images/login/findus_01.jpg",
    };
  },
  validations: {
    email: {
      email,
      required,
    },
    otp: {
      required,
    },
  },
  methods: {
    getImage() {
      const images = [
        "/static/images/login/findus_01.jpg",
        "/static/images/login/findus_02.jpg",
        "/static/images/login/findus_03.jpg",
        "/static/images/login/findus_04.jpg",
        "/static/images/login/findus_05.jpg",
        "/static/images/login/findus_06.jpg",
        "/static/images/login/findus_07.jpg",
        "/static/images/login/findus_08.jpg",
        "/static/images/login/findus_09.jpg",
      ];

      this.image = images[Math.floor(Math.random() * images.length)];
    },
    async verifyOtp() {
      this.loading = true;

      try {
        const response = await UsersService.verifyOtp(
          this.$db,
          this.email,
          this.otp
        );

        if (response === "User not found") {
          this.$toast.error("Nessun utente trovato con questo indirizzo email");
          this.email = "";
          this.otp = "";
        } else if (response === "Wrong OTP") {
          this.$toast.error("Codice OTP non corretto");
          this.otp = "";
        } else if (response === "Correct OTP") {
          location.href = "/login";
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Siamo spiacenti, si è verificato un errore.");
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getImage();
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/pages/login";
</style>



// WEBPACK FOOTER //
// src/pages/auth/otp/OtpPage.vue